import { Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { DynamicFormService } from '../dynamicform/service/dynamic-form.service';
import { GuestService } from '../services/guest.service';


@Directive({
  selector: '[customLoaderHandler]',
  standalone: false
})
export class CustomLoaderHandlerDirective implements OnDestroy{

  constructor(private activityService: GuestService) {
    this.activityService.cartLoader = true;
   }

   ngOnDestroy(): void {
    this.activityService.cartLoader = false;
   }

}
